import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo, useCallback } from 'react';
import { DateVectorRange } from '../utils/DateVectorRange';
export var useCommonDatePickerAllowedDates = function useCommonDatePickerAllowedDates(_ref, _ref2) {
  var dropdownOpen = _ref.dropdownOpen,
    currentDateVector = _ref.currentDateVector;
  var allowedDateRanges = _ref2.allowedDateRanges,
    isDateAllowed = _ref2.isDateAllowed,
    freeDateRanges = _ref2.freeDateRanges,
    isDateFree = _ref2.isDateFree;
  var isDateReallyAllowed = useMemo(function () {
    var ranges = [];
    var noRestrictions = allowedDateRanges === undefined;
    if (dropdownOpen && allowedDateRanges) {
      for (var i = 0; i < allowedDateRanges.length; i += 1) {
        var range = allowedDateRanges[i];
        var _range = _slicedToArray(range, 2),
          left = _range[0],
          right = _range[1];
        // everything is allowed
        if (left === null && right === null) {
          ranges = [new DateVectorRange()];
          break;
        }
        var dateRange = DateVectorRange.createFromLocalDateAdvancedRange(range, currentDateVector);
        if (!dateRange.isIllegal()) {
          ranges.push(dateRange);
        }
      }
    }
    return function (date) {
      if (noRestrictions && !isDateAllowed) {
        return true;
      }
      if (isDateAllowed === null || isDateAllowed === void 0 ? void 0 : isDateAllowed(date.convertToLocalDate())) {
        return true;
      }
      if (ranges.length) {
        for (var _i = 0; _i < ranges.length; _i += 1) {
          var _range2 = ranges[_i];
          if (_range2.contains(date)) {
            return true;
          }
        }
      }
      return false;
    };
  }, [dropdownOpen, currentDateVector, allowedDateRanges, isDateAllowed]);
  var isDateReallyFree = useMemo(function () {
    var ranges = [];
    var noRestrictions = freeDateRanges === undefined;
    if (dropdownOpen && freeDateRanges) {
      for (var i = 0; i < freeDateRanges.length; i += 1) {
        var range = freeDateRanges[i];
        var _range3 = _slicedToArray(range, 2),
          left = _range3[0],
          right = _range3[1];
        // everything is allowed
        if (left === null && right === null) {
          ranges = [new DateVectorRange()];
          break;
        }
        var dateRange = DateVectorRange.createFromLocalDateAdvancedRange(range, currentDateVector);
        if (!dateRange.isIllegal()) {
          ranges.push(dateRange);
        }
      }
    }
    return function (date) {
      if (noRestrictions && !isDateFree) {
        return true;
      }
      if (isDateFree === null || isDateFree === void 0 ? void 0 : isDateFree(date.convertToLocalDate())) {
        return true;
      }
      if (ranges.length) {
        for (var _i2 = 0; _i2 < ranges.length; _i2 += 1) {
          var _range4 = ranges[_i2];
          if (_range4.contains(date)) {
            return true;
          }
        }
      }
      return false;
    };
  }, [freeDateRanges, dropdownOpen, currentDateVector, isDateFree]);
  var isDateSelectable = useCallback(function (date) {
    // todo: optimise this: need to combine the internals of both functions to reduce amount of computations
    if (!isDateReallyAllowed(date)) {
      return false;
    }
    if (!isDateReallyFree(date)) {
      return false;
    }
    return true;
  }, [isDateReallyAllowed, isDateReallyFree]);
  return {
    isDateAllowed: isDateReallyAllowed,
    isDateFree: isDateReallyFree,
    isDateSelectable: isDateSelectable
  };
};